import * as mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { Component } from '@angular/core';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../shared/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { routes } from '../../../shared/routes/routes';
import { BookingLogService } from '../../../services/booking-log.service';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-ambulance-book',
  templateUrl: './ambulance-book.component.html',
  styleUrls: ['./ambulance-book.component.scss'],
})
export class AmbulanceBookComponent {
  showSuccess: boolean = false;
  proceedToPay: boolean = false;
  paymentStatus: any;
  home: boolean = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  ambulanceForm: any;
  bookingName: any;
  patientList: any = [];
  userProfile: any;
  bookingConfirmed: boolean = false;
  notEligiblie: boolean = false;
  pickupStates: any[] = [];
  pickupCities: any[] = [];
  dropStates: any[] = [];
  dropCities: any[] = [];
  countryDetails: any = [];
  isMapLoading = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private tosterService: ToastrService,
    private commonService: CommonService,
    private bookingLogService: BookingLogService,
  ) {
    this.ambulanceForm = this.fb.group(
      {
        patient: [null, Validators.required],
        age: [null, [Validators.required, Validators.min(18)]],
        gender: ['', Validators.required],
        phone: [null, [Validators.required, this.zimbabweMobileValidator()]],
        medicalReason: ['', Validators.required],

        pickLocation: ['', Validators.required],
        pick_lat: [null, Validators.required],
        pick_lng: [null, Validators.required],
        pick_city: ['', Validators.required],
        pick_state: ['', Validators.required],
        pick_country: ['', Validators.required],
        buildingPickLocation: ['', Validators.maxLength(100)],

        dropLocation: ['', Validators.required],
        drop_lat: [null, Validators.required],
        drop_lng: [null, Validators.required],
        drop_city: ['', Validators.required],
        drop_state: ['', Validators.required],
        drop_country: ['', Validators.required],
        buildingDropLocation: ['', Validators.maxLength(100)],
      },
      {
        validators: this.differentAddressValidator(),
      },
    );

    ['pick_country', 'pick_state', 'pick_city'].forEach((field) => {
      this.ambulanceForm.get(field)?.valueChanges.subscribe(() => {
        this.ambulanceForm.patchValue({
          buildingPickLocation: '',
          pickLocation: '',
        });
      });
    });

    ['drop_country', 'drop_state', 'drop_city'].forEach((field) => {
      this.ambulanceForm.get(field)?.valueChanges.subscribe(() => {
        this.ambulanceForm.patchValue({
          buildingDropLocation: '',
          dropLocation: '',
        });
      });
    });

    this.getAllPatient();
    this.getAllCountries();
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.userProfile.phone) {
      this.ambulanceForm.patchValue({
        phone: this.userProfile.phone,
      });
      this.ambulanceForm.get('phone')?.disable();
    }
    this.checkEligibility();
  }

  checkEligibility() {
    this.apiService
      .VerifyTentureStatus({
        feature_id: 2,
        type: 'Consultant',
        user_id: this.userProfile.user_id,
      })
      .subscribe(
        (res: any) => {
          localStorage.setItem(
            'consult_status',
            String(res?.sub_tenure_status),
          );
          if (res?.sub_tenure_status === false) {
            this.notEligiblie = true;
          } else {
            setTimeout(() => {
              this.commonService.addModalClosed();
              document.getElementById('openAddTeleModal')?.click();
            }, 100);
            this.notEligiblie = false;
          }
        },
        () => {
          this.tosterService.error('Error checking eligibility', '', {
            timeOut: 4000,
          });
        },
      );
  }

  // MAP

  routeDuration!: string;
  routeDistance!: string;

  pickupCoords!: [number, number];
  dropCoords!: [number, number];

  map!: mapboxgl.Map;
  marker!: mapboxgl.Marker;

  showMap = false;
  mapType: 'pickup' | 'drop' = 'pickup';
  mapMode: 'select' | 'route' = 'select';
  mapLoaded = false;

  selectedLat!: number;
  selectedLng!: number;
  selectedAddress = '';

  pickupAddressDetails: any;
  dropAddressDetails: any;

  openMap(type: 'pickup' | 'drop') {
    this.mapType = type;
    this.mapMode = 'select';
    this.showMap = true;
    this.isMapLoading = true;

    setTimeout(() => {
      this.useCurrentLocation(type);
    }, 200);
  }

  openMapAt(lng: number, lat: number) {
    if (this.map) {
      this.map.remove();
      this.map = undefined as any;
    }
    this.initMap([lng, lat]);
    this.updateMarker(lng, lat);
    this.reverseGeocode(lng, lat);
    this.isMapLoading = false;
  }

  openMapOnUserCity() {
    // const city = this.userProfile?.city;
    const city = 'Harare';

    if (!city) {
      this.openMapAt(-17.825387, 31.0534);
      return;
    }

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(city)}.json?access_token=${environment.mapboxToken}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const center = data.features?.[0]?.center;
        center
          ? this.openMapAt(center[0], center[1])
          : this.openMapAt(-17.825387, 31.0534);
      })
      .catch(() => this.openMapAt(-17.825387, 31.0534));
  }

  closeMap() {
    this.showMap = false;
    this.mapLoaded = false;
    this.isMapLoading = false;

    if (this.marker) {
      this.marker.remove();
      this.marker = undefined as any;
    }

    if (this.map) {
      this.map.remove();
      this.map = undefined as any;
    }

    const container = document.getElementById('map');
    if (container) {
      container.innerHTML = '';
    }
  }

  initMap(center: [number, number]) {
    if (this.map) return;

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/outdoors-v12',
      center,
      zoom: 12,
      accessToken: environment.mapboxToken,
    });

    this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    const geocoder = new MapboxGeocoder({
      accessToken: environment.mapboxToken,
      mapboxgl,
      marker: false,
      placeholder: 'Search location',
      language: 'en',
      types: 'address,place,locality,neighborhood,poi',
      limit: 7,
    });

    this.map.addControl(geocoder, 'top-left');

    this.map.once('load', () => {
      this.mapLoaded = true;
      this.isMapLoading = false;
      this.map.resize();

      this.map.setLayoutProperty('road-label', 'text-size', 14);

      this.map.setLayoutProperty('place-label', 'text-size', 16);
    });

    geocoder.on('result', (e: any) => {
      const [lng, lat] = e.result.center;
      this.setMarker(lng, lat);
      this.reverseGeocode(lng, lat);
      this.map.flyTo({ center: [lng, lat], zoom: 16 });
    });

    this.map.on('click', (e) => {
      const { lng, lat } = e.lngLat;
      this.setMarker(lng, lat);
      this.reverseGeocode(lng, lat);
    });
  }

  reverseGeocode(lng: number, lat: number) {
    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${environment.mapboxToken}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const feature = data.features?.[0];
        if (!feature) return;

        const context = feature.context || [];

        const addressDetails = {
          fullAddress: feature.place_name || '',
          pincode: this.getContextValue(context, 'postcode'),
          locality: this.getContextValue(context, 'locality'),
          city: this.getContextValue(context, 'place'),
          district: this.getContextValue(context, 'district'),
          state: this.getContextValue(context, 'region'),
          country: this.getContextValue(context, 'country'),
          latitude: lat,
          longitude: lng,
        };

        this.selectedAddress = addressDetails.fullAddress;

        if (this.mapType === 'pickup') {
          this.pickupAddressDetails = addressDetails;
        } else {
          this.dropAddressDetails = addressDetails;
        }
      });
  }

  getContextValue(context: any[], type: string): string {
    return context.find((c) => c.id.startsWith(type))?.text || '';
  }

  updateMarker(lng: number, lat: number) {
    this.selectedLng = lng;
    this.selectedLat = lat;

    if (this.marker) {
      this.marker.remove();
    }

    this.marker = new mapboxgl.Marker({ color: 'red' })
      .setLngLat([lng, lat])
      .addTo(this.map);
  }

  setMarker(lng: number, lat: number) {
    if (this.marker) this.marker.remove();

    this.marker = new mapboxgl.Marker({ color: '#e53935' })
      .setLngLat([lng, lat])
      .addTo(this.map);

    this.selectedLng = lng;
    this.selectedLat = lat;
  }

  useCurrentLocation(type: 'pickup' | 'drop') {
    this.mapType = type;
    let locationResolved = false;

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        if (locationResolved) return;
        locationResolved = true;

        navigator.geolocation.clearWatch(watchId);

        const lng = pos.coords.longitude;
        const lat = pos.coords.latitude;

        this.openMapAt(lng, lat);
      },
      () => {},
      {
        enableHighAccuracy: false,
        maximumAge: 10000,
      },
    );

    setTimeout(() => {
      if (!locationResolved) {
        navigator.geolocation.clearWatch(watchId);
        this.openMapOnUserCity();
      }
    }, 8000);
  }

  confirmLocation() {
    if (!this.marker) return;

    const address =
      this.mapType === 'pickup'
        ? this.pickupAddressDetails
        : this.dropAddressDetails;

    if (!address) return;

    if (this.mapType === 'pickup') {
      this.ambulanceForm.patchValue({
        pick_lat: this.selectedLat,
        pick_lng: this.selectedLng,
        pickLocation: this.selectedAddress,
      });
    } else {
      this.ambulanceForm.patchValue({
        drop_lat: this.selectedLat,
        drop_lng: this.selectedLng,
        dropLocation: this.selectedAddress,
      });
    }

    this.showMap = false;
  }

  initRouteMap() {
    const pickup: [number, number] = [
      this.ambulanceForm.value.pick_lng,
      this.ambulanceForm.value.pick_lat,
    ];

    const drop: [number, number] = [
      this.ambulanceForm.value.drop_lng,
      this.ambulanceForm.value.drop_lat,
    ];

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/navigation-day-v1',
      center: pickup,
      zoom: 12,
      accessToken: environment.mapboxToken,
    });

    new mapboxgl.Marker({ color: 'green' }).setLngLat(pickup).addTo(this.map);
    new mapboxgl.Marker({ color: 'red' }).setLngLat(drop).addTo(this.map);

    this.loadRouteFromBackend();
  }

  loadRouteFromBackend() {
    const { pick_lat, pick_lng, drop_lat, drop_lng } = this.ambulanceForm.value;

    this.apiService
      .getAmbulanceEndpoints({
        sourceLat: pick_lat,
        sourceLng: pick_lng,
        destLat: drop_lat,
        destLng: drop_lng,
      })
      .subscribe((res: any) => {
        if (!res.success || !res.routes?.length) return;

        this.clearRoutes();

        if (res.routes?.length) {
          this.drawRoute(res.routes[0], 0, true);
        }

        this.routeDistance = `${res.routes[0].distance_km} km`;
        this.routeDuration = `${res.routes[0].duration_min} min`;
      });
  }

  drawRoute(route: any, index: number, isPrimary = false) {
    const coords: [number, number][] = route.geometry.coordinates;

    const sourceId = `route-${index}`;
    const layerId = `route-layer-${index}`;

    this.map.addSource(sourceId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: coords,
        },
        properties: {},
      },
    });

    this.map.addLayer({
      id: layerId,
      type: 'line',
      source: sourceId,
      paint: {
        'line-color': isPrimary ? '#1f8ae8' : '#e95fd0',
        'line-width': isPrimary ? 8 : 8,
        'line-opacity': isPrimary ? 1 : 0.5,
      },
    });

    if (isPrimary) {
      this.fitBounds(coords);
      this.addRouteLabel(coords, route);
    }
  }

  fitBounds(coordinates: [number, number][]) {
    const bounds = new mapboxgl.LngLatBounds();

    coordinates.forEach((coord) => bounds.extend(coord));

    this.map.fitBounds(bounds, { padding: 60 });
  }

  addRouteLabel(coords: [number, number][], route: any) {
    const midIndex = Math.floor(coords.length / 2);

    new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(coords[midIndex])
      .setHTML(
        `
      <strong>${route.distance_km} km</strong><br/>
      ⏱ ${route.duration_min} min
    `,
      )
      .addTo(this.map);
  }

  clearRoutes() {
    const style = this.map.getStyle();
    if (!style?.layers) return;

    style.layers
      .filter((l) => l.id.startsWith('route-layer-'))
      .forEach((l) => this.map.removeLayer(l.id));

    Object.keys(this.map.getStyle().sources)
      .filter((id) => id.startsWith('route-'))
      .forEach((id) => this.map.removeSource(id));
  }

  differentAddressValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      if (!form) return null;

      const pick = {
        country: form.get('pick_country')?.value,
        state: form.get('pick_state')?.value,
        city: form.get('pick_city')?.value,
        building: this.normalizeAddress(
          form.get('buildingPickLocation')?.value || '',
        ),
        location: this.normalizeAddress(form.get('pickLocation')?.value || ''),
      };

      const drop = {
        country: form.get('drop_country')?.value,
        state: form.get('drop_state')?.value,
        city: form.get('drop_city')?.value,
        building: this.normalizeAddress(
          form.get('buildingDropLocation')?.value || '',
        ),
        location: this.normalizeAddress(form.get('dropLocation')?.value || ''),
      };

      // wait until all values exist
      const allPresent =
        pick.country &&
        pick.state &&
        pick.city &&
        pick.building &&
        pick.location &&
        drop.country &&
        drop.state &&
        drop.city &&
        drop.building &&
        drop.location;

      if (!allPresent) {
        return null;
      }

      const isSame =
        pick.country === drop.country &&
        pick.state === drop.state &&
        pick.city === drop.city &&
        pick.building === drop.building &&
        pick.location === drop.location;

      return isSame ? { sameAddress: true } : null;
    };
  }

  private normalizeAddress(address: string): string {
    return address?.toLowerCase()?.trim()?.replace(/\s+/g, ' ');
  }

  zimbabweMobileValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control?.value;
      if (!value) return { invalidZimbabweMobile: true };
      if (typeof value === 'object' && value.nationalNumber) {
        value = value.nationalNumber;
      }
      if (typeof value !== 'string') return { invalidZimbabweMobile: true };
      value = value.replace(/\s+/g, '');
      value = value.startsWith('0') ? value.substring(1) : value;
      const zimbabweMobileRegex = /^\d{9}$/;
      return zimbabweMobileRegex.test(value)
        ? null
        : { invalidZimbabweMobile: true };
    };
  }

  back() {
    this.proceedToPay = false;
    this.home = true;
    this.bookingConfirmed = false;
    this.ambulanceForm.patchValue({
      patient: this.paymentStatus.patient,
    });
  }

  getAllPatient() {
    this.apiService.getALLPatients().subscribe({
      next: (res: any) => {
        const allPatients = res.data || [];
        this.patientList = allPatients;
      },
      error: () => {},
    });
  }

  confirmAndBook() {
    this.proceedToPay = true;
    this.showMap = false;
    this.home = false;
    this.bookingConfirmed = false;

    const currentDate = new Date();

    this.paymentStatus = {
      ...this.ambulanceForm.value,
      booking_date: currentDate,
    };
  }

  validateAge() {
    const ageControl = this.ambulanceForm.get('age');
    if (ageControl) {
      const value = ageControl.value;
      if (value === null || value === '') {
        return;
      }
      if (value <= 0) {
        ageControl.setValue(1, { emitEvent: false });
      }
    }
  }

  blockInvalidKeys(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  proceed() {
    if (this.ambulanceForm.invalid) {
      this.ambulanceForm.markAllAsTouched();
      return;
    }

    this.mapMode = 'route';
    this.showMap = true;

    setTimeout(() => this.initRouteMap(), 0);
  }

  onBookingAmbulance(): void {
    this.spinner.show();
    console.log('onClick');
    const formValue = this.ambulanceForm.getRawValue();

    // const pickAddress = this.normalizeAddress(formValue.pickLocation || '');
    // const dropAddress = this.normalizeAddress(formValue.dropLocation || '');

    // if (pickAddress && dropAddress && pickAddress === dropAddress) {
    //   this.ambulanceForm.get('pickLocation')?.setErrors({ sameAddress: true });
    //   this.ambulanceForm.get('dropLocation')?.setErrors({ sameAddress: true });

    //   this.ambulanceForm.markAllAsTouched();
    //   this.spinner.hide();
    //   return;
    // }

    if (
      !formValue.patient?.user_id ||
      !formValue.pickLocation ||
      !formValue.dropLocation ||
      !formValue.pick_lat ||
      !formValue.pick_lng ||
      !formValue.drop_lat ||
      !formValue.drop_lng ||
      !formValue.pick_city ||
      !formValue.pick_state ||
      !formValue.pick_country ||
      !formValue.drop_city ||
      !formValue.drop_state ||
      !formValue.drop_country ||
      !formValue.phone?.number ||
      formValue.phone?.number?.replace(/\s/g, '').length !== 9 ||
      this.ambulanceForm.get('age')?.invalid ||
      !formValue.phone?.dialCode
    ) {
      this.ambulanceForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }

    // console.log('befire  payload');
    const payload: any = {
      user_id: formValue.patient?.user_id,
      phone_number: formValue.phone?.number?.replace(/\s/g, '') || '',
      country_dial_code: formValue.phone.dialCode,
      medical_condition: formValue.medicalReason || '',
      pickup_location: formValue.pickLocation || '',
      dropoff_location: formValue.dropLocation || '',
      pickup_lat: formValue.pick_lat || 0,
      pickup_lng: formValue.pick_lng || 0,
      dropoff_lat: formValue.drop_lat || 0,
      dropoff_lng: formValue.drop_lng || 0,
      pick_city: formValue.pick_city || null,
      pick_state: formValue.pick_state || null,
      pick_country: formValue.pick_country || null,
      drop_city: formValue.drop_city || null,
      drop_state: formValue.drop_state || null,
      drop_country: formValue.drop_country || null,
      building_pick_location: formValue.buildingPickLocation || null,
      building_drop_location: formValue.buildingDropLocation || null,
      is_al_carte: this.notEligiblie ? 1 : 0,
      channel_id: 1,
    };

    this.apiService.bookAmbulance(payload).subscribe(
      (res) => {
        this.tosterService.success('Ambulance booked successfully', '', {
          timeOut: 4000,
        });
        this.spinner.hide();
        const oldStatus = 'Null';
        const newStatus = 'NEW';
        const bookingData = res?.data;

        this.bookingLogService
          .logBookingAction(oldStatus, newStatus, bookingData, 'ambulance')
          .subscribe(
            (response) => {
              this.spinner.hide();
            },
            (error) => {
              this.spinner.hide();
              this.tosterService.error(
                error.error.message || error.error.error || 'An error occurred',
              );
            },
          );
        this.ambulanceForm.reset();
        this.bookingName = 'ambulance';
        this.bookingConfirmed = true;
        this.proceedToPay = false;
        this.home = false;
      },
      (err) => {
        this.spinner.hide();
        this.tosterService.error('Failed to book ambulance.', '', {
          timeOut: 4000,
        });
        console.error('Error book Ambulance:', err);
      },
    );
  }

  goToHome() {
    this.bookingConfirmed = false;
    this.proceedToPay = false;
    this.home = false;
    if (this.bookingName == 'ambulance') {
      this.router.navigate([routes.ambulance]);
    }
  }

  get ageCtrl() {
    return this.ambulanceForm.get('age');
  }

  cleanInput(event: KeyboardEvent) {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const isLetter = /^[a-zA-Z]$/.test(key);
    const isSpace = key === ' ';
    const isControlKey = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ].includes(key);

    if (
      !isLetter &&
      !(isSpace && value.length > 0 && !value.endsWith(' ')) &&
      !isControlKey
    ) {
      event.preventDefault();
    }
  }

  onPhoneInput(event: any): void {
    const input = event.target.value;
    const cleanedValue = input.replace(/\D/g, '');
    event.target.value = cleanedValue;
  }

  getAllCountries() {
    this.spinner.show();
    this.apiService.getAllCountries().subscribe(
      (res: any) => {
        this.countryDetails = res.data;
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching country:', err);
        this.spinner.hide();
      },
    );
  }

  onPatientChange(text: any) {
    const form = this.ambulanceForm;
    const patient = form.get('patient')?.value;
    if (!patient) return;

    const { gender, dob, booking_date, booking_time } = patient;

    delete patient.booking_date;
    delete patient.booking_time;

    let age = null;
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
    }

    form.patchValue({
      gender: gender?.toLowerCase() || '',
      age,
    });

    form.get('gender')?.enable();

    if (gender) {
      form.get('gender')?.disable();
    }

    form.get('age')?.enable();
    if (age !== null) {
      form.get('age')?.disable();
    }
  }

  onCountryChange(event: any, type: 'pickup' | 'drop') {
    const selectedCountryId = parseInt(event.target?.value || event);
    const selectedCountry = this.countryDetails.find(
      (c: any) => c.country_id === selectedCountryId,
    );

    const states = selectedCountry ? selectedCountry.states || [] : [];

    if (type === 'pickup') {
      this.pickupStates = states;
      this.pickupCities = [];
      this.ambulanceForm.patchValue({ pick_state: '', pick_city: '' });
    } else {
      this.dropStates = states;
      this.dropCities = [];
      this.ambulanceForm.patchValue({ drop_state: '', drop_city: '' });
    }
  }

  onStateChange(event: any, type: 'pickup' | 'drop') {
    const selectedStateId = parseInt(event.target?.value || event);
    const states = type === 'pickup' ? this.pickupStates : this.dropStates;

    const selectedState = states.find(
      (s: any) => s.state_id === selectedStateId,
    );

    const cities = selectedState ? selectedState.cities || [] : [];

    if (type === 'pickup') {
      this.pickupCities = cities;
      this.ambulanceForm.patchValue({ pick_city: '' });
    } else {
      this.dropCities = cities;
      this.ambulanceForm.patchValue({ drop_city: '' });
    }
  }
}
